/**
 *
 * https://www.apifox.cn/apidoc/shared-e68234d6-f79f-4d55-9847-d5964ae8f912/api-55544692
 *
 */

import { commonPromise } from '../index.js'

// 跨域代理前缀
// const API_PROXY_PREFIX = '/api'
const API_PROXY_PREFIX = ''
const BASE_URL = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_BASE_URL : API_PROXY_PREFIX
// const BASE_URL = process.env.VUE_APP_API_BASE_URL

const templateAndShare = {

  // APP、H5站内信
  siteInsideMsgEnable: (data) => commonPromise({ data, url: `${BASE_URL}/basic/siteInsideMessageSetting/enable`, method: 'post' }), // APP、H5站内信推送模板动作设置停用启用
  siteInsideMsgDetail: (data) => commonPromise({ data, url: `${BASE_URL}/basic/siteInsideMessageSetting/getByName`, method: 'post' }), // APP、H5站内信推送模板动作详情
  siteInsideMsgSave: (data) => commonPromise({ data, url: `${BASE_URL}/basic/siteInsideMessageSetting/save`, method: 'post' }), // APP、H5站内信推送模板动作设置保存
  siteInsideMsgSelectList: (data) => commonPromise({ data, url: `${BASE_URL}/basic/siteInsideMessageSetting/selectList`, method: 'post' }), // APP、H5站内信推送模板动作列表

  // 短信模板
  templateDataList: (data) => commonPromise({ data, url: `${BASE_URL}/basic/message/template/dataList`, method: 'post' }), // 短信模板列表查询（下拉数据）
  templateDetail: (data) => commonPromise({ data, url: `${BASE_URL}/basic/message/template/get`, method: 'post' }), // 短信模板详情查询
  refreshTemplate: (data) => commonPromise({ data, url: `${BASE_URL}/basic/message/template/refreshTemplate`, method: 'post' }), // 刷新消息模板

  getJhyxMessageActionSettingDetail: (data) => commonPromise({ data, url: `${BASE_URL}/basic/jhyxMessage/template/getJhyxMessageActionSettingDetail`, method: 'post' }), // 查询短信模板动作设置详情
  selectJhyxMessageActionSettingList: (data) => commonPromise({ data, url: `${BASE_URL}/basic/jhyxMessage/template/selectJhyxMessageActionSettingList`, method: 'post' }), // 查询短信模板动作设置列表
  saveJhyxMessageActionSetting: (data) => commonPromise({ data, url: `${BASE_URL}/basic/jhyxMessage/template/saveJhyxMessageActionSetting`, method: 'post' }), // 短信模板动作设置保存
  enableJhyxMessageActionSetting: (data) => commonPromise({ data, url: `${BASE_URL}/basic/jhyxMessage/template/enableJhyxMessageActionSetting`, method: 'post' }), // 短信模板动作设置停用启用
  
  jhyxTemplateDataList: (data) => commonPromise({ data, url: `${BASE_URL}/basic/jhyxMessage/template/dataList`, method: 'post' }), // 固定推送-短信模板列表查询（下拉数据）
  jhyxTemplateDetail: (data) => commonPromise({ data, url: `${BASE_URL}/basic/jhyxMessage/template/get`, method: 'post' }), // 固定推送-短信模板详情查询
  refreshJhyxTemplate: (data) => commonPromise({ data, url: `${BASE_URL}/basic/jhyxMessage/template/refreshTemplate`, method: 'post' }), // 固定推送-刷新消息模板

  // 固定推送
  allPrivateTemplate: (data) => commonPromise({ data, url: `${BASE_URL}/order/wechat/push/getAllPrivateTemplate`, method: 'post' }), // 获取模板列表(公众号)
  allMiniTemplate: (data) => commonPromise({ data, url: `${BASE_URL}/order/wechat/push/getAllMiniTemplate`, method: 'post' }), // 获取小程序订阅模板列表
  wxH5TemplateUpdate: (data) => commonPromise({ data, url: `${BASE_URL}/order/wechat/push/WxH5TemplateUpdate`, method: 'post' }), // 公众号模板消息状态变更接口开发（启用、停用）(公众号)
  wxMiniTemplateUpdate: (data) => commonPromise({ data, url: `${BASE_URL}/order/wechat/push/WxMiniTemplateUpdate`, method: 'post' }), // 九航小程序模板消息状态变更接口开发（启用、停用)

  // 分享配置
  shareList: (data) => commonPromise({ data, url: `${BASE_URL}/basic/share/config/list`, method: 'post' }), // 分享配置列表查询
  shareDelete: (data) => commonPromise({ data, url: `${BASE_URL}/basic/share/config/delete`, method: 'post' }), // 删除分享配置
  shareEdit: (data) => commonPromise({ data, url: `${BASE_URL}/basic/share/config/config`, method: 'post' }) // 编辑分享配置
}

export default templateAndShare
